export const toTitleCase = (word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

/** Converts a string to a normalized SCREAMING_SNAKE_CASE identifier (letters, digits, underscores only). */
export const toScreamingSnakeCase = (raw: string): string =>
  raw
    .toUpperCase()
    .replace(/[^A-Z0-9_]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');

/** Converts a SCREAMING_SNAKE_CASE identifier to Title Case words. */
export const screamingSnakeCaseToTitleCase = (id: string): string =>
  id
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const camelCaseToWords = (str: string) =>
  str
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
    .replace(/^./, (match) => match.toUpperCase()); // Capitalize the first letter
